import { render, staticRenderFns } from "./room-close.vue?vue&type=template&id=2fb1c05b"
import script from "./room-close.vue?vue&type=script&lang=js"
export * from "./room-close.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports